export const TOKEN_KEY = '@Fareye:AuthToken'
